import 'angular:locale/data:es';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "es";
